// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-form[data-v-2dc6f636]{margin:50px auto}.profile-form .row[data-v-2dc6f636]{line-height:38px}.fb-avatar-icon[data-v-2dc6f636],.line-avatar-icon[data-v-2dc6f636]{border-radius:20px}.level-tag[data-v-2dc6f636]{display:inline-flex;height:28px;padding-left:.4em;padding-right:.4em;align-items:center}", ""]);
// Exports
module.exports = exports;
